import { render, staticRenderFns } from "./commonDetail.vue?vue&type=template&id=4926a896&scoped=true&"
import script from "./commonDetail.vue?vue&type=script&lang=ts&"
export * from "./commonDetail.vue?vue&type=script&lang=ts&"
import style0 from "./commonDetail.vue?vue&type=style&index=0&id=4926a896&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4926a896",
  null
  
)

component.options.__file = "commonDetail.vue"
export default component.exports